<script lang="ts">
    import SettingsRow from './SettingsRow.svelte';
    import TemplateSettingsGeneral from './TemplateSettingsGeneral.svelte';
    import ButtonMain from '../../shared/ButtonMain.svelte';
    import { Navigation } from '../../utilities/Navigation.js';
</script>

<TemplateSettingsGeneral>
    <div slot="label">Customers</div>
    <div slot="content">
        <SettingsRow>
            <ButtonMain
                text="Customer list..."
                on:click={() => {
                    Navigation.navigate('/accounts');
                }}
            />
        </SettingsRow>
    </div>
</TemplateSettingsGeneral>
